export type TipoDocumentoCO = 'CC' | 'CE' | 'PA' | 'NIT';

export interface DatosRemitente {
  nombre: string;
  indicativoPais: string;
  numeroCelular: string;
  codigoPostal: string;
  municipio: string;
  codigoCm: string;
  codigoCiudadDane: string;
  colonia: string;
  direccion: string;
  detalleDireccion: string;
  correo: string;
  // Colombia
  tipoDocumento?: TipoDocumentoCO;
  identificacion?: string;
  tipoVia?: string;
  via?: string;
  numeroVia?: string;
  ciudadId?: string;
  ciudadLabel?: string;
}

export interface DatosDestinatario {
  nombre: string;
  indicativoPais: string;
  numeroCelular: string;
  codigoPostal: string;
  municipio: string;
  codigoCm: string;
  codigoCiudadDane: string;
  colonia: string;
  direccion: string;
  detalleDireccion: string;
  correo: string;
  // Colombia
  tipoDocumento?: TipoDocumentoCO;
  identificacion?: string;
  tipoVia?: string;
  via?: string;
  numeroVia?: string;
  ciudadId?: string;
  ciudadLabel?: string;
}

export type TipoProducto = 'paquete' | 'documento';
export type PesoDocumento = '1' | '2';
export type PagadorEnvio = 'remitente' | 'destinatario';

export interface DatosPaquete {
  largo: string;
  alto: string;
  ancho: string;
  peso: string;
  cantidad: number;
  contenido: string;
  // Colombia
  valorDeclarado?: string;
  codigoEvento?: string;
  observacionesGuia?: string;
  documentoReferencia?: string;
}

export interface DatosProducto {
  tipo: TipoProducto;
  paquetes: DatosPaquete[];
  contenidoDocumento: string;
  pesoDocumento: PesoDocumento;
  valorDeclarado: string;
  pagador: PagadorEnvio;
  // Colombia documento
  referenciaDocumento?: string;
}

export interface EnvioNacionalForm {
  remitente: DatosRemitente;
  destinatario: DatosDestinatario;
  producto: DatosProducto;
}

export const DATOS_REMITENTE_INITIAL: DatosRemitente = {
  nombre: '',
  indicativoPais: '52',
  numeroCelular: '',
  codigoPostal: '',
  municipio: '',
  codigoCm: '',
  codigoCiudadDane: '',
  colonia: '',
  direccion: '',
  detalleDireccion: '',
  correo: '',
};

export const DATOS_REMITENTE_CO_INITIAL: DatosRemitente = {
  nombre: '',
  indicativoPais: '57',
  numeroCelular: '',
  codigoPostal: '',
  municipio: '',
  codigoCm: '',
  codigoCiudadDane: '',
  colonia: '',
  direccion: '',
  detalleDireccion: '',
  correo: '',
  tipoDocumento: 'CC',
  identificacion: '',
  tipoVia: '',
  via: '',
  numeroVia: '',
  ciudadId: '',
  ciudadLabel: '',
};

export const DATOS_DESTINATARIO_INITIAL: DatosDestinatario = {
  nombre: '',
  indicativoPais: '52',
  numeroCelular: '',
  codigoPostal: '',
  municipio: '',
  codigoCm: '',
  codigoCiudadDane: '',
  colonia: '',
  direccion: '',
  detalleDireccion: '',
  correo: '',
};

export const DATOS_DESTINATARIO_CO_INITIAL: DatosDestinatario = {
  nombre: '',
  indicativoPais: '57',
  numeroCelular: '',
  codigoPostal: '',
  municipio: '',
  codigoCm: '',
  codigoCiudadDane: '',
  colonia: '',
  direccion: '',
  detalleDireccion: '',
  correo: '',
  tipoDocumento: 'CC',
  identificacion: '',
  tipoVia: '',
  via: '',
  numeroVia: '',
  ciudadId: '',
  ciudadLabel: '',
};

export const PAQUETE_INITIAL: DatosPaquete = {
  largo: '',
  alto: '',
  ancho: '',
  peso: '',
  cantidad: 1,
  contenido: '',
};

export const PAQUETE_CO_INITIAL: DatosPaquete = {
  ...PAQUETE_INITIAL,
  valorDeclarado: '',
  codigoEvento: '',
  observacionesGuia: '',
  documentoReferencia: '',
};

export const DATOS_PRODUCTO_INITIAL: DatosProducto = {
  tipo: 'paquete',
  paquetes: [{ ...PAQUETE_INITIAL }],
  contenidoDocumento: '',
  pesoDocumento: '1',
  valorDeclarado: '',
  pagador: 'remitente',
};

export const DATOS_PRODUCTO_CO_INITIAL: DatosProducto = {
  tipo: 'paquete',
  paquetes: [{ ...PAQUETE_CO_INITIAL }],
  contenidoDocumento: '',
  pesoDocumento: '1',
  valorDeclarado: '',
  pagador: 'remitente',
  referenciaDocumento: '',
};

export const getEnvioNacionalFormInitial = (pais: string): EnvioNacionalForm => {
  const esColombia = pais === 'CO';
  return {
    remitente:   esColombia ? { ...DATOS_REMITENTE_CO_INITIAL }   : { ...DATOS_REMITENTE_INITIAL },
    destinatario: esColombia ? { ...DATOS_DESTINATARIO_CO_INITIAL } : { ...DATOS_DESTINATARIO_INITIAL },
    producto:    esColombia ? { ...DATOS_PRODUCTO_CO_INITIAL, paquetes: [{ ...PAQUETE_CO_INITIAL }] } : { ...DATOS_PRODUCTO_INITIAL, paquetes: [{ ...PAQUETE_INITIAL }] },
  };
};

export const ENVIO_NACIONAL_FORM_INITIAL: EnvioNacionalForm = {
  remitente: DATOS_REMITENTE_INITIAL,
  destinatario: DATOS_DESTINATARIO_INITIAL,
  producto: DATOS_PRODUCTO_INITIAL,
};

// ─── Payload Colombia (estructura que va al backend dentro del carrito) ─────

export interface PersonaColombiaPayload {
  nombre: string;
  indicativoPais: string;
  numeroCelular: string;
  codigoCm: string;
  codigoCiudadDane: string;
  direccion: string;
  detalleDireccion: string;
  correo: string;
  identificacion: string;
  tipoDocumento: number;
  tipoVia: string;
  descripcionTipoVia: string;
  via: string;
  numero: string;
  otraDireccion: string;
}

export interface PaqueteColombiaPayload {
  largo: string;
  alto: string;
  ancho: string;
  peso: string;
  cantidad: number;
  contenido: string;
  valorDeclarado: number;
  referencia: string;
}

export interface ProductoColombiaPayload {
  tipo: string;
  contenidoDocumento: string;
  pesoDocumento: string;
  valorDeclarado: string;
  paquetes: PaqueteColombiaPayload[];
}

export interface EnvioNacionalColombiaPayload {
  valorRecaudar: number;
  referenciaRecaudo: string;
  referenciaGuia: string;
  observaciones: string;
  quienPagaEnvio: string;
  remitente: PersonaColombiaPayload;
  destinatario: PersonaColombiaPayload;
  producto: ProductoColombiaPayload;
}

/** Códigos numéricos de tipo de documento Colombia — verificar con backend si cambian */
const TIPO_DOC_CO: Record<string, number> = {
  CC: 13, NIT: 31, CE: 22, PA: 41,
};

const TIPO_DOC_CO_REV: Record<number, TipoDocumentoCO> = {
  13: 'CC', 31: 'NIT', 22: 'CE', 41: 'PA',
};

/**
 * Construye el objeto `envioNacionalColombia` que va dentro del item del carrito.
 * @param tiposViaCO Lista cargada desde /ventas/tipos-via para resolver el ID por descripción.
 */
export const buildEnvioNacionalColombiaPayload = (
  form: EnvioNacionalForm,
  tiposViaCO: { id: number | string; descripcion: string }[],
): EnvioNacionalColombiaPayload => {
  const { remitente, destinatario, producto } = form;

  const getTipoViaId = (desc: string): string =>
    String(tiposViaCO.find(t => t.descripcion === desc)?.id ?? '');

  const buildPersona = (p: DatosRemitente | DatosDestinatario): PersonaColombiaPayload => ({
    nombre:              p.nombre,
    indicativoPais:      p.indicativoPais,
    numeroCelular:       p.numeroCelular,
    codigoCm:            p.codigoCm,
    codigoCiudadDane:    p.ciudadId ?? '',
    direccion:           p.direccion,
    detalleDireccion:    p.detalleDireccion,
    correo:              p.correo,
    identificacion:      p.identificacion ?? '',
    tipoDocumento:       TIPO_DOC_CO[p.tipoDocumento ?? 'CC'] ?? 13,
    tipoVia:             getTipoViaId(p.tipoVia ?? ''),
    descripcionTipoVia:  p.tipoVia ?? '',
    via:                 p.via ?? '',
    numero:              p.numeroVia ?? '',
    otraDireccion:       p.direccion,
  });

  const quienPagaEnvio = producto.pagador === 'remitente' ? '1' : '2';
  const primerPaquete  = producto.tipo === 'paquete' ? producto.paquetes[0] : null;
  const referenciaGuia = primerPaquete?.documentoReferencia ?? producto.referenciaDocumento ?? '';
  const observaciones  = primerPaquete?.observacionesGuia ?? '';
  const valorDeclaradoGuia = producto.tipo === 'paquete'
    ? String(producto.paquetes.reduce(
        (acc, p) => acc + (Number(p.valorDeclarado ?? 0) || 0) * p.cantidad,
        0
      ))
    : producto.valorDeclarado;

  return {
    valorRecaudar:   0,
    referenciaRecaudo: '',
    referenciaGuia,
    observaciones,
    quienPagaEnvio,
    remitente:    buildPersona(remitente),
    destinatario: buildPersona(destinatario),
    producto: {
      tipo:               producto.tipo,
      contenidoDocumento: producto.contenidoDocumento,
      pesoDocumento:      producto.pesoDocumento,
      valorDeclarado:     valorDeclaradoGuia,
      paquetes: producto.paquetes.map(p => ({
        largo:          p.largo,
        alto:           p.alto,
        ancho:          p.ancho,
        peso:           p.peso,
        cantidad:       p.cantidad,
        contenido:      p.contenido,
        valorDeclarado: Number(p.valorDeclarado ?? 0),
        referencia:     p.documentoReferencia ?? '',
      })),
    },
  };
};

const personaFormDesdePayload = (p: PersonaColombiaPayload): DatosRemitente => ({
  ...DATOS_REMITENTE_CO_INITIAL,
  nombre: p.nombre,
  indicativoPais: p.indicativoPais,
  numeroCelular: p.numeroCelular,
  codigoCm: p.codigoCm,
  codigoCiudadDane: p.codigoCiudadDane,
  direccion: p.direccion,
  detalleDireccion: p.detalleDireccion,
  correo: p.correo,
  identificacion: p.identificacion,
  tipoDocumento: TIPO_DOC_CO_REV[p.tipoDocumento] ?? 'CC',
  tipoVia: p.descripcionTipoVia,
  via: p.via,
  numeroVia: p.numero,
  ciudadId: p.codigoCiudadDane,
  ciudadLabel: '',
});

/**
 * Reconstruye el wizard a partir del payload CO (carritos persistidos sin `envioNacionalForm`).
 */
export const formDesdePayloadColombia = (payload: EnvioNacionalColombiaPayload): EnvioNacionalForm => {
  const esDocumento = payload.producto.tipo === 'documento';
  const primerPaquete = payload.producto.paquetes[0];
  return {
    remitente: personaFormDesdePayload(payload.remitente),
    destinatario: personaFormDesdePayload(payload.destinatario),
    producto: {
      tipo: esDocumento ? 'documento' : 'paquete',
      paquetes: payload.producto.paquetes.map(p => ({
        ...PAQUETE_CO_INITIAL,
        largo: p.largo,
        alto: p.alto,
        ancho: p.ancho,
        peso: p.peso,
        cantidad: p.cantidad,
        contenido: p.contenido,
        valorDeclarado: String(p.valorDeclarado ?? 0),
        documentoReferencia: p.referencia,
        observacionesGuia: payload.observaciones,
      })),
      contenidoDocumento: payload.producto.contenidoDocumento,
      pesoDocumento: (payload.producto.pesoDocumento === '2' ? '2' : '1') as PesoDocumento,
      valorDeclarado: payload.producto.valorDeclarado,
      pagador: payload.quienPagaEnvio === '2' ? 'destinatario' : 'remitente',
      referenciaDocumento: esDocumento
        ? payload.referenciaGuia
        : (primerPaquete?.referencia ?? payload.referenciaGuia),
    },
  };
};
